<template>
    <v-card class="elevation-0 mx-8 pa-12">
        <v-card style="box-shadow:none; background:#e4e4e4b0">
            <v-row class="ma-0">
                <v-spacer/>
                <v-card-title class="pb-0">{{dateFormat(new_habit.created_at)}}</v-card-title>
                <v-spacer/>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="3" class="pb-0">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-card-subtitle class="pb-0" style="font-weight:500;">Horas de Sueño</v-card-subtitle>
                        <v-spacer/>
                    </v-row>
                    <v-slider class="px-2" v-model="new_habit.sleep_hours" step="10" thumb-label ticks></v-slider>
                </v-col>
                <v-col cols="3" class="pb-0">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-card-subtitle class="pb-0" style="font-weight:500;">Agua</v-card-subtitle>
                        <v-spacer/>
                    </v-row>
                    <v-slider class="px-2" v-model="new_habit.water_intake" step="10" thumb-label ticks></v-slider>
                </v-col>
                <v-col cols="3" class="pb-0">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-card-subtitle class="pb-0" style="font-weight:500;">Entrenamiento</v-card-subtitle>
                        <v-spacer/>
                    </v-row>
                    <v-slider class="px-2" v-model="new_habit.training_accomplishment" step="10" thumb-label ticks></v-slider>
                </v-col>
                <v-col cols="3" class="pb-0">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-card-subtitle class="pb-0" style="font-weight:500;">Dieta</v-card-subtitle>
                        <v-spacer/>
                    </v-row>
                    <v-slider class="px-2" v-model="new_habit.meal_plan_accomplishment" step="10" thumb-label ticks></v-slider>
                </v-col>
            </v-row>
            <v-row class="ma-0 pb-5">
                <v-spacer/>
                <v-btn @click="save()" :loading="saving" :disabled="saving" rounded color="primary" class="elevation-0">Guardar</v-btn>
                <v-spacer/>
            </v-row>
        </v-card>

        <v-card v-for="(habit, index) in habits" :key="index" class="my-3" style="box-shadow:none; border:2px solid #e4e4e4">
            <v-row class="ma-0">
                <v-spacer/>
                <v-card-title class="pb-0">{{dateFormat(habit.created_at)}}</v-card-title>
                <v-spacer/>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="3">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-card-subtitle class="pb-0" styl2="font-weight:500;">Horas de Sueño</v-card-subtitle>
                        <v-spacer/>
                    </v-row>
                    <v-row class="ma-0">
                        <v-spacer/>
                        <div :style="(index+1)==habits.length?'background:#1876d2':(habit.sleep_hours>habits[index+1].sleep_hours?'background:green;':(habit.sleep_hours<habits[index+1].sleep_hours?'background:#e12826;':'background:#1876d2'))" style="color:white; font-weight:600; border-radius:50%; padding:12px 10px;">{{habit.sleep_hours}}%</div>
                        <v-spacer/>
                    </v-row>
                    
                </v-col>
                <v-col cols="3">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-card-subtitle class="pb-2" style="font-weight:500;">Agua</v-card-subtitle>
                        <v-spacer/>
                    </v-row>
                    <v-row class="ma-0">
                        <v-spacer/>
                        <div :style="(index+1)==habits.length?'background:#1876d2':(habit.water_intake>habits[index+1].water_intake?'background:green;':(habit.water_intake<habits[index+1].water_intake?'background:#e12826;':'background:#1876d2'))" style="color:white; font-weight:600; border-radius:50%; padding:12px 10px;">{{habit.water_intake}}%</div>
                        <v-spacer/>
                    </v-row>
                    
                </v-col>
                <v-col cols="3">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-card-subtitle class="pb-2" style="font-weight:500;">Entrenamiento</v-card-subtitle>
                        <v-spacer/>
                    </v-row>
                    <v-row class="ma-0">
                        <v-spacer/>
                        <div :style="(index+1)==habits.length?'background:#1876d2':(habit.training_accomplishment>habits[index+1].training_accomplishment?'background:green;':(habit.training_accomplishment<habits[index+1].training_accomplishment?'background:#e12826;':'background:#1876d2'))" style="color:white; font-weight:600; border-radius:50%; padding:12px 10px;">{{habit.training_accomplishment}}%</div>
                        <v-spacer/>
                    </v-row>
                    
                </v-col>
                <v-col cols="3">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <v-card-subtitle class="pb-2" style="font-weight:500;">Dieta</v-card-subtitle>
                        <v-spacer/>
                    </v-row>
                    <v-row class="ma-0">
                        <v-spacer/>
                        <div :style="(index+1)==habits.length?'background:#1876d2':(habit.meal_plan_accomplishment>habits[index+1].meal_plan_accomplishment?'background:green;':(habit.training_accomplishment<habits[index+1].training_accomplishment?'background:#e12826;':'background:#1876d2'))" style="color:white; font-weight:600; border-radius:50%; padding:12px 10px;">{{habit.meal_plan_accomplishment}}%</div>
                        <v-spacer/>
                    </v-row>
                    
                </v-col>
            </v-row>
        </v-card>
        
    </v-card>
</template>

<script>
import axios from "axios"
export default {
    data(){
        return{
            new_habit:{
                created_at:new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}),
                sleep_hours:0,
                water_intake:0,
                training_accomplishment:0,
                meal_plan_accomplishment:0,
                user_id: this.$route.params.id
            },
            habits:[
                
            ],
            saving:false
        }
    },
    created(){
        this.getDataFromApi()
    },
    mounted(){
        this.getDataFromApi()
    },
    methods:{
        dateFormat(date){
            if(date!=undefined){
                const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
                return date.slice(8,10) + ' de ' + meses[(date.slice(5,7)*1)-1] + ' de ' + date.slice(0,4)
            }   
        },
        save(){
            this.saving = true
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/user_habits", this.new_habit).then(res => {
                this.new_habit = {
                    created_at:'6 de agosto de 2024',
                    sleep_hours:0,
                    water_intake:0,
                    training_accomplishment:0,
                    meal_plan_accomplishment:0,
                    user_id: this.$route.params.id
                }
                this.saving = false
                this.getDataFromApi()
            }).catch(error=>{
                this.saving = false
            })
        },
        getDataFromApi(){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users/" + this.$route.params.id).then(res => {
                this.habits = res.data.data.user_habits
            })
        }
    }
}
</script>

<style>

</style>